import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface RaspiMenuProps {
  raspiId: string;
  raspiStatus: string;
  isViewer: boolean;
  triggerUnauthorized: () => void;
  onLoadRaspiData: (raspiId: string) => void;
  onCleanRaspiFiles: (raspiId: string) => void;
  onRebootRaspi: (raspiId: string) => void;
  onRestartRaspiSoftware: (raspiId: string) => void;
  onUpdateRaspiSoftware: (raspiId: string) => void;
}

const RaspiMenu: React.FC<RaspiMenuProps> = ({
  raspiId,
  raspiStatus,
  isViewer,
  triggerUnauthorized,
  onLoadRaspiData,
  onCleanRaspiFiles,
  onRebootRaspi,
  onRestartRaspiSoftware,
  onUpdateRaspiSoftware,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Helper to wrap action with auth check
  const handleAction = (action: (raspiId: string) => void) => {
    handleMenuClose();
    if (isViewer) {
      triggerUnauthorized();
    } else {
      action(raspiId);
    }
  };

  return (
    <>
      <IconButton size="small" onClick={handleMenuOpen} disabled={raspiStatus === 'DISCONNECTED'}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => handleAction(onLoadRaspiData)}>
          <Typography variant="body2">LOAD RASPI DATA</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleAction(onCleanRaspiFiles)}>
          <Typography variant="body2">CLEAR RASPI FILES</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleAction(onRebootRaspi)}>
          <Typography variant="body2">REBOOT RASPI</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleAction(onRestartRaspiSoftware)}>
          <Typography variant="body2">RESTART RASPI SOFTWARE</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleAction(onUpdateRaspiSoftware)}>
          <Typography variant="body2">UPDATE RASPI SOFTWARE</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default RaspiMenu; 